"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _isBrowser = _interopRequireDefault(require("./isBrowser"));

var isCmsRoute = function isCmsRoute() {
  return (0, _isBrowser.default)() && window.location.pathname.includes('/cms');
};

var _default = isCmsRoute;
exports.default = _default;